import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth from "../../services/authService";
import Joi from "joi-browser";
import { toast, cssTransition } from "react-toastify";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import { addReviewNotes, getAllNotes, getNotesAddedStatus, loadAllReviewNotes, reviewNotesAdded } from "../../app/store/reviewNotes";
import { getCurrentUser } from "../../app/store/auth";
import { allowFormLibraryEdit, formLibraryEditAllowed, getFormLibraryEditStatus } from "../../app/store/forms";

const AddEditNotes = (props) => {
  const { noteShowHide, handleNoteShowHide, notesType,
    candidateObj, timeLogObj, selectedObj } = props;

  const [allNotes, setAllNotes] = useState([]);
  const [notes, setNotes] = useState("");
  const [btnAddedStatus, setBtnAddedStatus] = useState(false);
  const [expandedNotes, setExpandedNotes] = useState({});

  const allNotesSelector = useSelector(getAllNotes);
  const notesAddedStatusSelector = useSelector(getNotesAddedStatus);
  const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);

  const dispatch = useDispatch();

  const currentUser = getCurrentUser();

  useEffect(() => {
    if (candidateObj?.performerid) {
      dispatch(loadAllReviewNotes(notesType, candidateObj.performerid))
    }
  }, [candidateObj]);

  useEffect(() => {
    if (allNotesSelector.length > 0 && timeLogObj?.id > 0) {
      let filterNotes = allNotesSelector;

      if (timeLogObj?.id > 0)
        filterNotes = filterNotes.filter((x) => x.ciid === timeLogObj.id);

      setAllNotes(filterNotes);
      setNotes("");
      if (btnAddedStatus) {
        setBtnAddedStatus(false);
        handleNoteShowHide("save", "");
      }
    }
  }, [allNotesSelector]);

  useEffect(() => {
    if (allNotesSelector.length > 0 && timeLogObj?.id > 0) {
      let filterNotes = allNotesSelector;

      if (timeLogObj?.id > 0)
        filterNotes = filterNotes.filter((x) => x.ciid === timeLogObj.id);

      setAllNotes(filterNotes);
      setNotes("");

    }
  }, [timeLogObj])

  const doSubmit = async () => {
    if (notesType === "formEditReq") {
      const result = await getConfirmAlert("Warning", "Are you sure you want to give permission to Edit this Form?", "warning");
      if (result.isConfirmed) {
        dispatch(allowFormLibraryEdit(selectedObj.id, 1, notes));
      }
    } else {
      const frmData = new FormData();
      frmData.append("comment", notes);
      frmData.append("type", notesType);
      frmData.append("userId", currentUser.id);
      frmData.append("performerId", candidateObj.performerid);
      if (timeLogObj?.id > 0)
        frmData.append("ciid", timeLogObj.id);

      const result = await getConfirmAlert("Warning", "Are you sure you want to add this Note?", "warning");
      if (result.isConfirmed)
        dispatch(addReviewNotes(frmData));
    }
  };

  useEffect(() => {
    if (notesAddedStatusSelector) {
      getAlert("", "Note Added Successfully", "success");
      setBtnAddedStatus(true);
      if (candidateObj?.performerid) {
        dispatch(loadAllReviewNotes(notesType, candidateObj.performerid));
      }
      dispatch(reviewNotesAdded(false));
    }
  }, [notesAddedStatusSelector]);

  useEffect(() => {
    if (formLibraryEditStatusSelector) {
      getAlert("", "Allowed Successfully", "success");
      dispatch(formLibraryEditAllowed(false));
      handleNoteShowHide("save", "");
    }
  }, [formLibraryEditStatusSelector]);


  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-notes-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-notes-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-notes-modal {
          --task-accent: #2563eb; /* Primary Blue */
          --task-soft: #f8fafc;   /* Default soft gray background */
          max-width: 95% !important;
          width: 800px !important;
        }

        .wf-notes-modal .modal-content {
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border: none !important;
        }

        .wf-notes-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-notes-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }

        .wf-notes-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 14px !important;
          width: 100% !important;
        }

        .wf-notes-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }

        .wf-notes-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-notes-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }

        .wf-notes-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .wf-notes-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .wf-notes-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .wf-notes-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }

        .wf-notes-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-notes-modal .rt-modal-desc i {
          color: var(--task-accent) !important;
        }

        .wf-notes-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 240px) !important;
          overflow-y: auto !important;
        }

        body.modal-open .modal:has(.wf-notes-modal) {
          overflow-y: hidden !important;
        }

        .wf-notes-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .wf-notes-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .wf-notes-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .wf-notes-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .wf-notes-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        .wf-notes-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }

        .wf-notes-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-notes-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
        }

        .wf-notes-modal .wf-btn-send {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          height: 38px !important;
          padding: 0 24px !important;
          border-radius: 8px !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 700 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
        }
        .wf-notes-modal .wf-btn-send:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-notes-modal .wf-btn-send:active {
          transform: scale(0.97) !important;
        }
        .wf-notes-modal .wf-btn-send:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }

        .wf-notes-modal .wf-notes-table-wrap {
          border: 1px solid #cbd5e1 !important;
          border-radius: 12px !important;
          overflow: hidden !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
          max-height: 350px !important;
          overflow-y: auto !important;
          margin-bottom: 24px !important;
          background: #ffffff !important;
        }

        .wf-notes-modal .wf-notes-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
          font-size: 13.5px !important;
          margin: 0 !important;
        }

        .wf-notes-modal .wf-notes-table thead th {
          position: sticky !important;
          top: 0 !important;
          background: #f8fafc !important;
          color: #475569 !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          font-size: 11px !important;
          padding: 12px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          z-index: 10 !important;
          box-shadow: inset 0 -1px 0 #e2e8f0 !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr {
          transition: background-color 0.2s ease !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr:hover {
          background-color: #f8fafc !important;
        }

        .wf-notes-modal .wf-notes-table tbody td {
          padding: 14px 16px !important;
          vertical-align: top !important;
          border-bottom: 1px solid #edf2f7 !important;
          color: #334155 !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        .wf-notes-modal .wf-notes-date-cell {
          font-weight: 600 !important;
          color: #334155 !important;
          white-space: nowrap !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-notes-modal .wf-notes-date-cell i {
          color: #4f46e5 !important;
        }

        .wf-notes-modal .wf-notes-time-cell {
          font-weight: 500 !important;
          color: #64748b !important;
          white-space: nowrap !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-notes-modal .wf-notes-time-cell i {
          color: #0ea5e9 !important;
        }

        .wf-notes-modal .wf-notes-comment-wrap {
          position: relative !important;
        }

        .wf-notes-modal .wf-notes-comment {
          white-space: pre-wrap !important;
          word-break: break-word !important;
          line-height: 1.6 !important;
          color: #1e293b !important;
          font-weight: 500 !important;
          font-size: 13.5px !important;
          transition: color 0.2s ease !important;
        }

        .wf-notes-modal .wf-notes-comment.wf-clickable {
          cursor: pointer !important;
        }

        .wf-notes-modal .wf-notes-comment.wf-clickable:hover {
          color: #2563eb !important;
        }

        .wf-notes-modal .wf-notes-expand-hint {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          color: #2563eb !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-top: 5px !important;
          background: #eff6ff !important;
          padding: 2px 6px !important;
          border-radius: 4px !important;
          border: 1px solid rgba(37, 99, 235, 0.1) !important;
        }

        .wf-notes-modal .wf-notes-author-cell {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          min-width: 200px !important;
        }

        .wf-notes-modal .wf-notes-avatar {
          width: 32px !important;
          height: 32px !important;
          border-radius: 50% !important;
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
          color: #1e40af !important;
          font-weight: 800 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 12.5px !important;
          border: 1px solid #bfdbfe !important;
          flex-shrink: 0 !important;
          margin-top: 2px !important;
        }

        .wf-notes-modal .wf-notes-author-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          white-space: nowrap !important;
        }

        .wf-notes-modal .wf-notes-author-name {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
        }

        .wf-notes-modal .wf-notes-author-email {
          font-size: 11px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          line-height: 1 !important;
          white-space: nowrap !important;
        }

        .wf-notes-modal .wf-notes-author-email i {
          color: #3b82f6 !important;
          flex-shrink: 0 !important;
        }

        .wf-notes-modal .wf-notes-author-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 2px 6px !important;
          border-radius: 4px !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #eff6ff !important;
          color: #2563eb !important;
          border: 1px solid rgba(37, 99, 235, 0.1) !important;
          margin-top: 3px !important;
          width: fit-content !important;
        }

        .wf-notes-modal .wf-textarea-label {
          display: block !important;
          font-size: 13px !important;
          font-weight: 800 !important;
          color: #1e3a8a !important;
          margin-bottom: 8px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }

        .wf-notes-modal .wf-textarea-input {
          background: #ffffff !important;
          border: 1.5px solid #cbd5e1 !important;
          border-radius: 10px !important;
          padding: 12px 16px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          transition: all 0.2s ease !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          min-height: 90px !important;
          resize: vertical !important;
          outline: none !important;
        }

        .wf-notes-modal .wf-textarea-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
        }
      `}} />
      <Modal show={noteShowHide} size="xl" dialogClassName="wf-notes-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-commenting-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{notesType === "formEditReq" ? "Allow Edit Form" : "Notes Log"}</span>
                      <span className="rt-modal-title-badge">{notesType === "formEditReq" ? "Request" : "Comments"}</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> View, add, or manage review comments and notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleNoteShowHide("", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            {notesType !== "formEditReq" && (
              <div className="col-md-12">
                {allNotes.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "40px 10px", color: "#64748b", background: "#f8fafc", borderRadius: "12px", border: "1px dashed #cbd5e1", marginBottom: "20px" }}>
                    <div style={{ fontSize: "24px", marginBottom: "8px", color: "#94a3b8" }}><i className="fa fa-comment-o" /></div>
                    <div style={{ fontWeight: 700, fontSize: "14px", color: "#475569" }}>No Notes Yet</div>
                    <div style={{ fontSize: "12.5px", color: "#94a3b8", marginTop: "2px" }}>Be the first to add a note below.</div>
                  </div>
                ) : (
                  <div className="wf-notes-table-wrap">
                    <table className="wf-notes-table">
                      <thead>
                        <tr>
                          <th style={{ width: "160px" }}>Date & Time</th>
                          <th style={{ width: "240px" }}>Added By</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allNotes.map((item, key) => {
                          const initials = item.performer ? item.performer.charAt(0).toUpperCase() : "N";

                          const metadataParts = [];
                          if (item.role) metadataParts.push(item.role);
                          if (item.department) metadataParts.push(item.department);
                          if (item.partner) metadataParts.push(item.partner);
                          const metadataStr = metadataParts.join(" • ");

                          const noteId = item.id || key;
                          const isExpanded = expandedNotes[noteId];
                          const shouldTruncate = item.comments && item.comments.length > 45;
                          const displayText = shouldTruncate && !isExpanded
                            ? `${item.comments.substring(0, 45)}...`
                            : item.comments;

                          return (
                            <tr key={noteId}>
                              <td>
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                  <span className="wf-notes-date-cell">
                                    <i className="fa fa-calendar-o" aria-hidden="true" />
                                    <Moment format="MMM Do YYYY">{item.dateTime}</Moment>
                                  </span>
                                  <span className="wf-notes-time-cell">
                                    <i className="fa fa-clock-o" aria-hidden="true" />
                                    <Moment format="h:mm a">{item.dateTime}</Moment>
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="wf-notes-author-cell">
                                  <div className="wf-notes-avatar">
                                    {initials}
                                  </div>
                                  <div className="wf-notes-author-info">
                                    <span className="wf-notes-author-name">{item.performer}</span>
                                    {item.email && (
                                      <span className="wf-notes-author-email">
                                        <i className="fa fa-envelope-o" />
                                        {item.email}
                                      </span>
                                    )}
                                    {metadataStr && (
                                      <span className="wf-notes-author-badge">
                                        {metadataStr}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="wf-notes-comment-wrap">
                                  <div
                                    className={`wf-notes-comment ${shouldTruncate ? "wf-clickable" : ""}`}
                                    title={item.comments}
                                    onClick={shouldTruncate ? () => setExpandedNotes(prev => ({ ...prev, [noteId]: !isExpanded })) : undefined}
                                  >
                                    {displayText}
                                  </div>
                                  {shouldTruncate && (
                                    <div
                                      className="wf-notes-expand-hint"
                                      onClick={() => setExpandedNotes(prev => ({ ...prev, [noteId]: !isExpanded }))}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className={`fa fa-chevron-${isExpanded ? "up" : "down"}`} />
                                      {isExpanded ? "Show less" : "Show more"}
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            <div className="col-md-12">
              <label htmlFor="notes" className="wf-textarea-label">New Note</label>
              <textarea
                cols={2}
                rows={2}
                className="form-control wf-textarea-input"
                id="notes"
                name="notes"
                placeholder="Type your notes or comments here..."
                value={notes}
                onChange={({ currentTarget }) => setNotes(currentTarget.value)}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleNoteShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-send"
            disabled={!notes}
            onClick={doSubmit}
          >
            <i className="fa fa-paper-plane" aria-hidden="true"></i> {notesType !== "formEditReq" ? "Send" : "Allow"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddEditNotes;
